import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  restoreSidePanelState,
  type SidePanelState,
  selectActiveSidePanelItemKey,
  selectSidePanelFullScreen,
  selectSidePanelItems,
  selectSidePanelOpen,
} from '../redux/slices/side-panel-slice';

const SIDE_PANEL_STORAGE_KEY = 'dashboard-sidePanelState';

export const useSidePanelPersistence = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectSidePanelOpen);
  const isFullScreen = useSelector(selectSidePanelFullScreen);
  const items = useSelector(selectSidePanelItems);
  const activeItemKey = useSelector(selectActiveSidePanelItemKey);
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasLoadedRef.current) return;

    try {
      const saved = localStorage.getItem(SIDE_PANEL_STORAGE_KEY);
      if (saved) {
        const state: SidePanelState = JSON.parse(saved);
        dispatch(restoreSidePanelState(state));
      }
    } catch (error) {
      console.error('Error loading persisted side panel state:', error);
    }

    hasLoadedRef.current = true;
  }, []);

  useEffect(() => {
    if (!hasLoadedRef.current) return;

    try {
      const stateToSave: SidePanelState = {
        isOpen,
        isFullScreen,
        items: items.map((item) => ({ ...item, title: item.title ?? '' })),
        activeItemKey,
      };

      localStorage.setItem(SIDE_PANEL_STORAGE_KEY, JSON.stringify(stateToSave));
    } catch (error) {
      console.error('Error saving side panel state:', error);
    }
  }, [isOpen, isFullScreen, items, activeItemKey]);
};
